module.exports = __webpack_public_path__ + "img/pop-up-empty-list-light.cda0578b.svg";